import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of, switchMap } from 'rxjs';
import { HttpError, HttpResponse } from '@shared/utils/models/http.model';
import { PublicDemandInterestFormService } from '../services/public-demand-interest-form.service';
import {
  PublicDemandInterestFormActions,
  PublicDemandInterestFormResetActions,
} from '../actions/public-demand-interest-form.actions';
import {
  PublicDemandInterestFormDetails,
  SendPublicDemandInterestFormResponse,
} from '@features/public-demand-interest-form/utils/models/public-demand-interest-form.model';

@Injectable()
export class PublicDemandInterestFormEffects {
  private readonly publicDemandInterestFormService = inject(PublicDemandInterestFormService);
  private readonly actions$ = inject(Actions);

  validateDemandInterestForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        PublicDemandInterestFormActions.validateDemandInterestForm,
        PublicDemandInterestFormResetActions.cancelPublicDemandInterestFormActions
      ),
      switchMap((action) =>
        action.type === PublicDemandInterestFormResetActions.cancelPublicDemandInterestFormActions.type
          ? of(PublicDemandInterestFormResetActions.cancelPublicDemandInterestFormActionsSuccess())
          : this.publicDemandInterestFormService.validateDemandInterestForm(action.demandHash).pipe(
              map((response: HttpResponse<PublicDemandInterestFormDetails>) =>
                PublicDemandInterestFormActions.validateDemandInterestFormSuccess({ data: response.message })
              ),
              catchError((error: HttpError) =>
                of(PublicDemandInterestFormActions.validateDemandInterestFormFailure({ error }))
              )
            )
      )
    );
  });

  sendDemandInterestForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicDemandInterestFormActions.sendDemandInterestForm),
      exhaustMap((action) =>
        this.publicDemandInterestFormService.sendDemandInterestForm(action.payload).pipe(
          map((response: HttpResponse<SendPublicDemandInterestFormResponse>) =>
            PublicDemandInterestFormActions.sendDemandInterestFormSuccess({ data: response.message })
          ),
          catchError((error: HttpError) => of(PublicDemandInterestFormActions.sendDemandInterestFormFailure({ error })))
        )
      )
    );
  });
}
